var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Title", {
        attrs: {
          pages: [{ icon: "folder", page: _vm.page_title.toUpperCase() }],
        },
      }),
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-1" },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.updateDialog(true)
                        },
                      },
                    },
                    [_vm._v("Crear " + _vm._s(_vm.modal_title))]
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "search",
                      label: "Buscar",
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "mt-0 mb-4" },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "12" } },
                [
                  _c("Breadcrumbs", {
                    attrs: {
                      navigationStack: _vm.navigationStack,
                      selectedFolder: _vm.selectedFolder,
                    },
                    on: {
                      "reset-navigation": _vm.resetNavigation,
                      "go-to-folder": _vm.goToFolder,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.create_access
            ? _c("Modal", {
                attrs: {
                  button_name: _vm.$t("Crear") + " " + _vm.modal_title,
                  modal_title: _vm.modal_title,
                  formBtn: _vm.formBtn,
                  dialog: _vm.dialog,
                  parent: _vm.parent,
                  service: _vm.service,
                  item: _vm.mainItem,
                  selectedFolder: _vm.selectedFolder,
                },
                on: {
                  updateDialog: _vm.updateDialog,
                  loadList: function ($event) {
                    return _vm.loadList(_vm.service)
                  },
                  updateItem: (newItem) => {
                    _vm.mainItem = newItem
                  },
                },
              })
            : _vm._e(),
          !_vm.selectedFolder
            ? _c("ListFolder", {
                attrs: {
                  folders: _vm.filteredFoldersView,
                  loading_folders: _vm.loading,
                },
                on: {
                  "open-folder": _vm.openFolder,
                  editItem: _vm.editItem,
                  deleteItem: _vm.deleteItem,
                },
              })
            : _c("ListSubFolder", {
                attrs: {
                  folderData: _vm.filteredFoldersView,
                  loading_folders: _vm.loading,
                },
                on: {
                  "go-back": _vm.goBack,
                  "open-folder": _vm.openFolder,
                  editItem: _vm.editItem,
                  deleteItem: _vm.deleteItem,
                },
              }),
          _c("DialogDelete", {
            attrs: {
              dialog_delete: _vm.dialog_delete,
              subtext:
                "Eliminarás todos los archivos y subcarpetas contenidos en ella en todos los legajos del sistema.",
            },
            on: {
              updateDialogDelete: _vm.updateDialogDelete,
              deleteItemConfirm: _vm.deleteItemConfirm,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }